import type { CityConfig } from "../city-template/types";

export const southCharlestonConfig: CityConfig = {
  city: "South Charleston",
  state: "West Virginia",
  stateAbbr: "WV",
  slug: "south-charleston",
  route: "/cities/south-charleston",
  title: "Emergency Passport South Charleston, WV — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in South Charleston, WV — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Kanawha Valley, WV State Police HQ, and CRW airport via Charleston.",
  h1: "Emergency & Expedited Passport Services in South Charleston, WV",
  heroSubtitle: "Charleston flight to Cancun in 7 days? WV State Police HQ international conference in the UK? BridgeValley CTC study abroad in Barcelona? We help South Charleston residents — from Spring Hill families to WV Regional Tech Park professionals to South Charleston Memorial Hospital staff — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20view%20of%20South%20Charleston%20West%20Virginia%20historic%20downtown%20along%20MacCorkle%20Avenue%20in%20the%20Kanawha%20River%20Valley%2C%20the%20South%20Charleston%20Mound%20historic%20Native%20American%20earthwork%20landmark%20visible%2C%20mix%20of%20historic%20brick%20buildings%20and%20modern%20commercial%20development%2C%20tree-covered%20hills%20rising%20behind%20the%20city%2C%20warm%20golden%20hour%20light%2C%20Kanawha%20Valley%20community%20atmosphere&width=1800&height=700&seq=south-charleston-hero-2026&orientation=landscape",
  heroImageAlt: "South Charleston West Virginia downtown along MacCorkle Avenue in Kanawha River Valley",
  geoPosition: "38.3534;-81.6996",
  geoPlacename: "South Charleston, West Virginia",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 340 miles from South Charleston — appointments required, typically booked 2+ weeks out.",
  },
  nearbyCitiesZips: [
    { name: "South Charleston", zips: "25303, 25309" },
    { name: "Charleston", zips: "25301, 25302" },
    { name: "Dunbar", zips: "25064" },
    { name: "St. Albans", zips: "25177" },
    { name: "Institute", zips: "25112" },
    { name: "Nitro", zips: "25143" },
    { name: "Cross Lanes", zips: "25313" },
    { name: "Teays Valley", zips: "25526" },
    { name: "Hurricane", zips: "25526" },
    { name: "Winfield", zips: "25213" },
  ],
  benefits: [
    { icon: "ri-flight-takeoff-line", title: "CRW Airport — 20 Minutes from South Charleston", desc: "Yeager Airport (CRW) is just 10 miles from South Charleston via I-64 — about 20 minutes door to gate. Direct flights to Charlotte, Atlanta, Chicago, and DC for international connections. West Virginia International Yeager Airport serves as the region's primary air hub." },
    { icon: "ri-building-2-line", title: "WV State Police HQ & Kanawha Valley Employment Hub", desc: "South Charleston is home to WV State Police Headquarters and the West Virginia Regional Technology Park — a major tech employment center. International conferences, federal task force meetings, and tech industry travel create steady passport demand." },
    { icon: "ri-graduation-cap-line", title: "BridgeValley CTC & Education Hub", desc: "BridgeValley Community and Technical College and WV State University proximity create a student travel corridor. Study abroad programs, mission trips, and spring break international travel drive significant student passport demand." },
    { icon: "ri-shield-check-line", title: "Kanawha Valley — Charleston Adjacency Advantage", desc: "South Charleston sits in the heart of the Kanawha Valley, directly adjacent to the state capital. Access to the same federal and state resources as Charleston — but with a more suburban, family-friendly pace. All passport acceptance facilities within minutes." },
  ],
  testimonials: [
    {
      name: "David M.",
      location: "Spring Hill, South Charleston",
      rating: 5,
      text: "WV State Police sent me to an international law enforcement conference in London with 11 days notice. My passport was expiring and I panicked. They processed my renewal in 6 days — made the flight out of CRW with a day to spare.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Sarah T.",
      location: "South Charleston",
      rating: 5,
      text: "BridgeValley study abroad to Costa Rica — I waited too long to start the passport process. The remote service was perfect. Did the acceptance visit at Charleston post office, shipped documents, and had my passport in 9 days. No stress.",
      service: "New Passport — Expedited",
    },
    {
      name: "The Williams Family",
      location: "South Charleston",
      rating: 5,
      text: "Family cruise out of Miami — needed new passports for our two kids plus renewal for my wife. All three handled together, all arrived in 10 days. The checklist made it easy to track everything. CRW flight was smooth sailing.",
      service: "Multiple Passport Services",
    },
    {
      name: "Greg P.",
      location: "South Charleston",
      rating: 5,
      text: "Tech Park contractor deploying to Frankfurt for three months. Needed a second passport since my primary was tied up with the German consulate for a work visa. Second passport arrived in 8 days — deployment on schedule.",
      service: "Second Passport — Expedited",
    },
  ],
  facilities: [
    {
      id: "south-char-1",
      name: "South Charleston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "321 4th Ave",
      city: "South Charleston",
      state: "WV",
      zip: "25303",
      phone: "(304) 744-6483",
      hours: "Mon–Fri 9:00 AM – 3:00 PM (appointment required)",
      distance: "South Charleston — 4th Avenue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for South Charleston residents. Convenient downtown location. Limited afternoon hours — book appointments early in the week.",
      icon: "ri-mail-line",
    },
    {
      id: "south-char-2",
      name: "Charleston Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1002 Lee St E",
      city: "Charleston",
      state: "WV",
      zip: "25301",
      phone: "(304) 347-5421",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Charleston — 5 miles north, Kanawha County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Largest facility in the region with most appointment availability. Just 10 minutes from South Charleston via I-64. Passport photos available on-site. Convenient for Jefferson Road and downtown South Charleston residents.",
      icon: "ri-mail-line",
    },
    {
      id: "south-char-3",
      name: "Kanawha County Circuit Clerk",
      type: "County Clerk Passport Acceptance",
      address: "409 Virginia St E, Room 202",
      city: "Charleston",
      state: "WV",
      zip: "25301",
      phone: "(304) 357-0440",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      distance: "Downtown Charleston — Kanawha County Courthouse",
      website: "https://www.kanawha.us/circuit-clerk",
      websiteLabel: "Kanawha County Circuit Clerk",
      notes: "County clerk acceptance counter. Often less crowded than the post office. No photo services on-site. Convenient for South Charleston residents who work in downtown Charleston.",
      icon: "ri-government-line",
    },
    {
      id: "south-char-4",
      name: "Dunbar Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 12th St",
      city: "Dunbar",
      state: "WV",
      zip: "25064",
      phone: "(304) 768-0163",
      hours: "Mon–Fri 9:00 AM – 3:00 PM (appointment required)",
      distance: "Dunbar — 3 miles west, Kanawha County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Alternative facility with good appointment availability for western South Charleston and Dunbar residents. About 5 minutes from MacCorkle Avenue.",
      icon: "ri-mail-line",
    },
    {
      id: "south-char-5",
      name: "Cross Lanes Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5480 Big Tyler Rd",
      city: "Cross Lanes",
      state: "WV",
      zip: "25313",
      phone: "(304) 776-1407",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Cross Lanes — 6 miles north, Kanawha County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Alternative facility for northern Kanawha Valley residents. Convenient for Cross Lanes and the northern part of South Charleston near the Tech Park.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    { q: "How fast can I get a passport in South Charleston?", a: "We offer South Charleston-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. The nearest passport agency is in Detroit (340 miles) — making courier service the faster and far more practical option." },
    { q: "Do I need to visit an office in South Charleston?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (South Charleston Post Office or Charleston Main Post Office), then ship documents overnight. We handle the State Department submission and return your passport to your South Charleston address." },
    { q: "Which airport should South Charleston travelers use?", a: "Yeager Airport (CRW) in Charleston is the primary airport — just 10 miles from South Charleston via I-64 (about 20 minutes). CRW offers direct flights to Charlotte, Atlanta, Chicago, and DC for international connections. Columbus (CMH) and Pittsburgh (PIT) are alternatives about 2.5 hours away." },
    { q: "Can I use Charleston or Dunbar acceptance facilities?", a: "Yes — many South Charleston residents use the Charleston Main Post Office (5 miles north) or Dunbar Post Office (3 miles west). Both are fully valid options and often have better appointment availability than South Charleston's post office." },
    { q: "What is the best price for expedited passport service in South Charleston?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. Best price guarantee included." },
    { q: "Where can I get passport photos in South Charleston?", a: "Walgreens on MacCorkle Avenue, CVS Pharmacy on D Street, and the Charleston Main Post Office all offer passport photos. Walmart Supercenter in South Charleston on MacCorkle Avenue also provides photo services." },
    { q: "How do BridgeValley students handle passport timing?", a: "BridgeValley CTC and WV State University students: start your passport application when you apply to a study abroad program — not when you're accepted. Acceptance-to-departure windows are often only 4–6 weeks. We provide student-specific guidance and checklists tailored to Kanawha Valley programs." },
    { q: "Does the WV State Police HQ affect passport processing?", a: "WV State Police headquarters in South Charleston generates steady international travel for training conferences, task force meetings, and interagency collaborations. Law enforcement travel authorizations often come with 7–14 days notice. We understand public safety professional travel timelines." },
    { q: "How do I check my passport status from South Charleston?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online status system. Processing from submission to return typically matches your chosen speed tier." },
    { q: "Can I get same-day passport service in South Charleston?", a: "Same-day service is available for life-or-death emergencies through the Washington DC Passport Agency (340 miles, appointment required). For non-emergency situations, our fastest courier service begins at 24 hours — dramatically more practical for Kanawha Valley residents." },
  ],
  photoLocations: [
    { name: "Walgreens — MacCorkle Ave", address: "5060 MacCorkle Ave, South Charleston, WV 25309", hours: "Daily 8 AM – 10 PM" },
    { name: "CVS Pharmacy — D Street", address: "412 D St, South Charleston, WV 25303", hours: "Daily 8 AM – 9 PM" },
    { name: "Walmart Supercenter — MacCorkle Ave", address: "2700 Mountaineer Blvd, South Charleston, WV 25309", hours: "Daily 6 AM – 11 PM" },
    { name: "Charleston Main Post Office", address: "1002 Lee St E, Charleston, WV 25301", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Walgreens — Kanawha Blvd (Charleston)", address: "4000 Kanawha Blvd E, Charleston, WV 25301", hours: "Daily 8 AM – 10 PM" },
  ],
  dmvLocations: [
    {
      name: "WV DMV — Charleston Regional Office",
      address: "5707 MacCorkle Ave SE, Charleston, WV 25304",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, state ID cards. Located on MacCorkle Avenue near South Charleston. Appointment recommended.",
      featured: true,
    },
  ],
  dmvWebsite: "https://transportation.wv.gov/dmv/",
  dmvLabel: "West Virginia DMV — Official Website",
  airports: [
    {
      code: "CRW",
      name: "West Virginia International Yeager Airport",
      distance: "About 10 miles north of South Charleston via I-64",
      address: "100 Airport Rd, Charleston, WV 25311",
      note: "Primary airport for Kanawha Valley travelers. Direct flights to Charlotte (CLT), Atlanta (ATL), Chicago (ORD), and Washington Dulles (IAD) for international connections. About 20 minutes from South Charleston.",
      flightUrl: "https://yeagerairport.com/",
      flightLabel: "Yeager Airport Website",
      featured: true,
    },
    {
      code: "CMH",
      name: "John Glenn Columbus International Airport",
      distance: "About 155 miles northwest of South Charleston via I-77",
      address: "4600 International Gateway, Columbus, OH 43219",
      note: "Second option for international flights with more direct international routes. About 2.5 hours via I-77. Direct flights to Toronto, Cancun, and Caribbean destinations.",
      flightUrl: "https://flycolumbus.com/",
      flightLabel: "Columbus Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate — WV DHHR",
      desc: "Request certified birth certificates from the West Virginia DHHR Vital Registration Office in Charleston.",
      url: "https://dhhr.wv.gov/bph/hsc/vital/Pages/default.aspx",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate — Kanawha County",
      desc: "Request marriage license records from the Kanawha County Clerk for name changes and passport applications.",
      url: "https://www.kanawha.us/county-clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree — Kanawha County",
      desc: "Obtain certified divorce records through the Kanawha County Circuit Clerk for name change passport corrections.",
      url: "https://www.kanawha.us/circuit-clerk",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate — WV DHHR",
      desc: "Certified death certificates through WV DHHR for estate and legal matters.",
      url: "https://dhhr.wv.gov/bph/hsc/vital/Pages/default.aspx",
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Charleston flight to London in two days? WV State Police conference with short notice? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help South Charleston residents renew fast — no agency visit required. Perfect for Tech Park professionals and Kanawha Valley families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport — First Time",
      description: "First-time applicants require an in-person acceptance visit. We guide South Charleston residents through every step with clear instructions.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require DS-64 and additional documentation. We guide you through everything to avoid costly mistakes.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear checklists.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Kanawha Valley business and Tech Park professionals.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Kanawha Valley travelers through the process.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "Wallet-size travel document for land and sea crossings to Canada, Mexico, Caribbean, and Bermuda.",
      bullets: ["Wallet-size convenience", "Land and sea travel", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport South Charleston WV", description: "Urgent passport processing for South Charleston West Virginia travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal South Charleston WV", description: "Fast passport renewal for South Charleston West Virginia residents." },
    { name: "First-Time Passport South Charleston WV", description: "New passport application services for South Charleston West Virginia residents." },
    { name: "Child Passport South Charleston WV", description: "Minor passport services for South Charleston West Virginia families." },
    { name: "Name Change Passport South Charleston WV", description: "Passport name correction for South Charleston residents." },
    { name: "Second Passport South Charleston WV", description: "Second passport services for South Charleston business and frequent travelers." },
  ],
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Confusing CRW Airport with a Major International Hub",
      description: "Yeager Airport (CRW) is wonderfully convenient — just 20 minutes away. But CRW offers regional and domestic connections, not direct international flights. Budget connection time at Charlotte, Atlanta, or DC for international travel. A 6 AM CRW departure for a 2 PM international connection is standard.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Waiting Until WV State Police Travel Authorization Is Finalized",
      description: "WV State Police and law enforcement professionals sometimes wait for formal travel authorization before starting passport applications. Travel authorizations often come 7–14 days before departure — not enough time for standard processing. Start passport applications when travel is anticipated, not when it's confirmed.",
    },
    {
      icon: "ri-error-warning-line",
      title: "BridgeValley Study Abroad — Last-Minute Rush",
      description: "BridgeValley and WVSU students: study abroad acceptance letters arrive 4–6 weeks before departure. That's exactly the minimum standard processing window. Start the passport application when you apply — if you wait for acceptance, you're gambling with your trip.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Photos from local pharmacies and big-box stores frequently fail State Department standards. We review all photos before submission to prevent rejection and delay.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Assuming Same-Day Detroit Agency Access Is Easy",
      description: "The Washington DC Passport Agency is 340 miles away — a 5+ hour drive each way. Agency appointments are booked 2+ weeks out and primarily serve life-or-death emergencies. For non-emergency travel, our courier service is dramatically more practical.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order — just a few minutes from your South Charleston home." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist tailored to your departure airport — CRW or Columbus." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most South Charleston clients use the UPS Store on MacCorkle Avenue or ship from the South Charleston post office." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency channel — faster than a Detroit agency appointment, no 340-mile drive required." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport arrives at your South Charleston address within your selected timeframe. No long drive, no appointment scramble." },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned", "Daily status updates"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "In-person clerk appointment required", "No document review", "No dedicated agent", "Updates only by mail", "Can't upgrade speed after submission"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — nearest is Detroit (340 miles)", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Detroit agency is 340 miles away. Booked 2+ weeks out", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — 340-mile drive to Detroit", fpc: "Most South Charleston travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission" },
    { feature: "Local Guidance", agency: "Generic — no Kanawha Valley or CRW expertise", fpc: "Full South Charleston/Kanawha Valley knowledge" },
    { feature: "Cost vs Resellers", agency: "Government fees only — you handle all logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Fast passport services in Charleston, WV", route: "/cities/charleston" },
    { name: "Expedited passport in St. Albans, WV", route: "/cities/st-albans" },
    { name: "Quick passport services in Huntington, WV", route: "/cities/huntington" },
    { name: "Urgent passport services in Beckley, WV", route: "/cities/beckley" },
    { name: "West Virginia passport services overview", route: "/states/west-virginia" },
  ],
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, Maryland 20814",
  fpcOfficeNote: "Fast Passport Center serves South Charleston via secure registered courier with direct access to regional passport agencies. Our registered couriers hand-deliver your documents — meaning you get faster results without the 340-mile Detroit drive. South Charleston residents can ship from any UPS Store, FedEx Office, or post office in the Kanawha Valley.",
  fpcOfficeDistance: "Serving South Charleston, Charleston, Dunbar, Institute, Nitro, St. Albans, and all Kanawha Valley communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout South Charleston and the Kanawha Valley. From Spring Hill to the WV Regional Technology Park, from Jefferson Road to MacCorkle Avenue — we serve all South Charleston neighborhoods. Our courier service provides faster processing than a Detroit agency appointment.",
  nearbyCitiesIntro: "We serve South Charleston and all Kanawha Valley communities including Charleston, Dunbar, St. Albans, Institute, Nitro, and Cross Lanes. We also serve nearby communities in the Teays Valley area (Hurricane, Winfield). Travelers depart from Yeager Airport (CRW) and Columbus (CMH).",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in South Charleston as simple and predictable as possible. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you.",
  mistakesIntro: "South Charleston travelers encounter unique passport issues — from CRW connection timing to BridgeValley study abroad deadlines to WV State Police travel authorization windows. Here are the most common mistakes we see.",
  testimonialsIntro: "South Charleston travelers — from WV State Police professionals and WV Regional Tech Park employees to BridgeValley students and Kanawha Valley families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in South Charleston, WV? Here are the most common ones from Kanawha Valley travelers.",
  statePageRoute: "/states/west-virginia",
  statePageName: "West Virginia",
  servicesIntro: "Whether you need a renewal before a CRW flight to Cancun, an emergency passport for a WV State Police conference, or a first-time passport for a BridgeValley study abroad — Fast Passport Center handles it with reserved courier submission. As a registered State Department courier, we guarantee the best price.",
  travelTiming: {
    title: "Travel & Passport Timing for South Charleston Residents",
    intro: "South Charleston's position in the Kanawha Valley with CRW airport access and proximity to Charleston creates distinct travel patterns.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "CRW — Yeager Airport",
        subtitle: "10 miles north via I-64, primary regional gateway",
        description: "Yeager Airport serves as the primary airport for South Charleston travelers with direct flights to Charlotte, Atlanta, Chicago, and Washington DC for international connections. The I-64 drive takes about 20 minutes. CRW is small and efficient — you can arrive 60–75 minutes before domestic flights.",
        tip: "CRW's runway sits atop a flattened mountain — the unique approach can be affected by Kanawha Valley fog in fall and winter mornings. Book late morning or afternoon connections if possible during fog season.",
      },
      {
        icon: "ri-building-2-line",
        title: "WV State Police & Tech Park Professional Travel",
        subtitle: "Law enforcement and tech industry international trips",
        description: "South Charleston's WV State Police HQ and WV Regional Technology Park generate steady professional international travel for conferences, interagency meetings, and contractor deployments. Travel authorizations often arrive 7–14 days before departure.",
        tip: "Law enforcement and tech professionals: your security clearance or visa status is separate from passport readiness. Maintain a current passport independently — when travel orders come, there's no time for standard processing.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Kanawha Valley Location = CRW Access, Columbus Backup",
      description: "South Charleston's Kanawha Valley position means 20-minute access to CRW for regional connections and 2.5-hour access to Columbus (CMH) for more international routes. Our courier service provides faster passport processing without the 340-mile Detroit drive.",
    },
  },
  destinations: {
    title: "Where South Charleston Travelers Go",
    intro: "South Charleston's Kanawha Valley location, state government proximity, and tech/education hub status create distinct international travel patterns.",
    stats: [
      { stat: "35%", label: "of South Charleston expedited requests are professional or government-related" },
      { stat: "1–2 Weeks", label: "average lead time for law enforcement and tech contractor travel" },
      { stat: "CRW", label: "dominant airport for 80%+ of Kanawha Valley international departures" },
      { stat: "6 Days", label: "shortest turnaround for a WV State Police conference traveler" },
    ],
    destinations: [
      { name: "United Kingdom", context: "Law enforcement conferences, Tech Park business partnerships, CRW to Charlotte/Atlanta to London connections", urgency: "Professional travel authorizations 7–14 days before departure", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "Tech Park contractor deployments, chemical industry supplier meetings", urgency: "Deployment dates fixed and often short-notice", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "CRW connecting flights, family resort vacations, winter getaways", urgency: "Vacation bookings peak January–March", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Law enforcement interagency meetings, Tech Park collaborations", urgency: "Meeting dates often 1–2 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Costa Rica & Central America", context: "BridgeValley study abroad, mission trips, eco-tourism", urgency: "Study abroad acceptance 4–6 weeks before departure", icon: "ri-map-pin-2-line" },
      { name: "Italy & Spain", context: "BridgeValley & WVSU study abroad, healthcare conferences", urgency: "Program dates fixed 6–12 weeks in advance", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other West Virginia Service Areas",
    crossLinksDesc: "We serve travelers across the Mountain State.",
    crossLinks: [
      { name: "Charleston", route: "/cities/charleston" },
      { name: "Huntington", route: "/cities/huntington" },
    ],
  },
};